import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import usersRequest from "../../request/usersRequest";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";

const ConfirmCodePage = () => {
	const [searchParams] = useSearchParams();
	const [email, setEmail] = useState(searchParams.get("email") || "");
	const [code, setCode] = useState(searchParams.get("code") || "");

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");

	const { language } = useContext(CombinedContext);
	const navigate = useNavigate();

	const handleConfirm = async () => {
		setError("");
		setLoading(true);

		try {
			await usersRequest.confirmSignUp({ email, code });
			navigate("/signin");
		} catch (err) {
			console.error("Confirmation failed:", err);
			setError(err.message || "Invalid confirmation code");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="container">
			<div className="card" style={{ maxWidth: 400, margin: "40px auto" }}>
				<div className="hd">
					<div>{translations[language].confirmationCode.title}</div>
				</div>

				<div className="bd">
					<input className="input" placeholder={translations[language].confirmationCode.email} value={email} onChange={(e) => setEmail(e.target.value)} style={{ marginBottom: 10 }} />

					<input className="input" placeholder={translations[language].confirmationCode.code} value={code} onChange={(e) => setCode(e.target.value)} style={{ marginBottom: 10 }} />

					<button className="btn brand" style={{ width: "100%", marginBottom: 10 }} onClick={handleConfirm} disabled={loading}>
						{loading ? translations[language].confirmationCode.loading : translations[language].confirmationCode.button}
					</button>

					{error && (
						<div className="sub" style={{ color: "red", marginBottom: 10 }}>
							{error}
						</div>
					)}

					<div className="sub">
						<Link to="/signin">{translations[language].confirmationCode.backToLogin}</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ConfirmCodePage;
